<template>
  <div class="OurService">
    <!-- 黑头 -->
    <div class="header flex-all-center">
        <p>{{ $t("ourServices.title") }}</p>
    </div>
    <!-- 正文-->
    <div class="main">
      
      <div class="service-item">
        <div class="service-overlay">
          <div class="service-text">{{ $t("ourServices.text1") }}</div>
          <router-link to="/ourServiceBank">
            <el-button>{{ $t("home.learnMore") }}</el-button>
          </router-link>
        </div>
      </div>

      <div class="service-item">
        <div class="service-overlay">
          <div class="service-text">{{ $t("home.text5") }}</div>
          <router-link to="/ourServiceFixed">
            <el-button>{{ $t("home.learnMore") }}</el-button>
          </router-link>
        </div>
      </div>

      <div class="service-item">
        <div class="service-overlay">
          <div class="service-text">{{ $t("home.text6") }}</div>
          <router-link to="/ourServiceDigital">
            <el-button>{{ $t("home.learnMore") }}</el-button>
            </router-link>
        </div>
      </div>

      <div class="service-item">
        <div class="service-overlay">
          <div class="service-text">{{ $t("home.text7") }}</div>
          <router-link to="/ourServiceAI">
            <el-button>{{ $t("home.learnMore") }}</el-button>
            </router-link>
        </div>
      </div>

    </div>
    <div class="footer"></div>
  </div>
</template>

<script>

export default {
  name: "OurService",
  components: {
    // Tabbar,
  },
  data() {
    return {
    };
  },
  computed: {},
  created() {

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.OurService{
    color: #000;
    width: 100%;

  .header {
    height: 400px;
    background: #000;
    font-family: "OPPO-L";
    font-size: 42px;
    color: #fff;
    width: 100%;
    p {
    text-align: center;
    }
  }

  .main {
    margin-top: 80px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .service-item {
      position: relative;
      width: 300px;
      height: 400px;
      margin-left: 20px;
      margin-top: 0px;
      background-image: url("../../assets/images/home_overlap.jpg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      //background-attachment: fixed;

      .service-overlay {
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        margin-top: 80px;            
        background-color: rgba(0, 0, 0, 0);
        color: white;
        
        .service-text {
          height: 100px;
          font-size: 20px;
          margin-bottom: 80px;
          text-align: center;
        }

        el-button {
          background-color: white;
          color: black;
          border-radius: 4px;
          padding: 8px 16px;
        }
      }
    }
  }

  .footer{
      margin-top: 120px;
  }
}


@media (max-width: 768px) {

.OurService{
  color: #000;
  width: 100%;

  .main {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .service-item {
      position: relative;
      width: 90%;
      height: 400px;
      background-image: url("../../assets/images/home_overlap.jpg");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      //background-attachment: fixed;
      margin-left: 0px;
      margin-top: 20px;
    }
  }

  .footer{
      margin-top: 40px;
  }
}

}
</style>
